import {
  authenticatedRequestForFormData,
  preAuthApiEndUserService,
} from './AuthService';

const checkCardEligibility = async (lookup_value: number, token: string) => {
  try {
    const payload = {
      lookup_value: lookup_value,
      captcha_token: token,
    };

    const response = await authenticatedRequestForFormData(
      preAuthApiEndUserService,
      '/api/priceless/check/eligibility',
      'post',
      payload
    );

    return response;
  } catch (error) {
    console.error('API Error ', error);
    throw error;
  }
};

const confirmRedemption = async (redemption_id: string) => {
  try {
    const payload = {
      redemption_id: redemption_id,
    };

    const response = await authenticatedRequestForFormData(
      preAuthApiEndUserService,
      '/api/priceless/redemption/confirm',
      'post',
      payload
    );

    return response;
  } catch (error) {
    console.error('API Error ', error);
    throw error;
  }
};

export { checkCardEligibility, confirmRedemption };
